import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import AssignToButton from './AssignToButton'

export default class ReadyForFeedback extends Component {
  render() {
    const { handleClick } = this.props
    return (
      <div id="readyForFeedback">
        <div className="ready-for-feedback-img" />
        <div className="assignment-area-label">
          <FormattedMessage
            id={'Quest.Review.AssignmentArea.ReadyForFeedback?'}
            defaultMessage="Ready for feedback?"
          />
        </div>
        <AssignToButton handleClick={handleClick} />
      </div>
    )
  }
}

ReadyForFeedback.propTypes = {
  handleClick: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/assignment/ReadyForFeedback.js